<template>
  <a :href="p2pUrl">
    <div class="banner-root">
      <div class="banner-icon"></div>
      <div class="banner-text">
        {{ $t('WithdrawToCard | p2pBannerText') }}
      </div>
      <div class="arrow-right"><svg-icon name="arrow-right" /></div>
    </div>
  </a>
</template>

<script>
import SvgIcon from '@/shared/ui/SvgIcon/SvgIcon.vue'
import { CONFIG } from '@/app/config/config'

export default {
  components: {
    SvgIcon,
  },
  computed: {
    p2pUrl() {
      return `${CONFIG.EMCD_URL}/p2p`
    },
  },
}
</script>

<style scoped lang="scss">
.banner-root {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .banner-icon {
    content: '';
    background-image: url('../../shared/assets/images/p2p-banner-coins.png');
    background-size: cover;
    width: min(224px, 30vw);
    height: min(112px, 15vw);
    position: absolute;
    left: calc(50% + 13px);

    @media (max-width: 576px) {
      left: calc(50% + 6px);
      transform: translateY(0%);
    }
  }
}

.banner-text {
  flex-basis: 50%;
  color: var(--text-6);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%; /* 19.6px */
}

.arrow-right {
  padding: 5px;
  border-radius: 8px;
  background: var(--bg-4);
}
</style>
